// material-ui
import logo from "assets/images/logo.png";
import qLogo from "assets/images/q.png";
import { useSelector } from "react-redux";
import { SettingsState, Store } from "../../store/types";
import { buildImageUrl } from "../../utils/static-files";

/**
 * if you want to use image instead of <svg> uncomment following.
 *
 * import logoDark from 'assets/images/logo-dark.svg';
 *
 */

// ==============================|| LOGO SVG ||============================== //

type LogoProps = {
  width?: number | null;
  height?: number;
  ignoreBranding?: boolean;
  open?: boolean;
};

const Logo = ({
                width = null,
                height = 35,
                ignoreBranding = false,
                open = false
              }: LogoProps) => {
  const { branding } = useSelector<Store, SettingsState>(
    state => state.settings
  );

  const autoHeight = Boolean(branding?.logo && !ignoreBranding);

  return (
    <img
      src={
        branding?.logo && !ignoreBranding
          ? buildImageUrl(branding.logo, width, height)
          : open ? logo : qLogo
      }
      alt={branding && !ignoreBranding ? branding.systemName : "q-live"}
      height={branding?.logo && !ignoreBranding ? 35 : height}
      style={{
        width: open ? 'auto' : '100%',
        height: autoHeight ? 'auto' : height,
        paddingLeft: open ? 0 : 10,
        paddingRight: open ? 0 : 10
      }}
    />
  );
};

export default Logo;
